import { VStack } from "@/components/Elements/Layouts/Stack";
import { UserText } from "@/components/Elements/Texts/UserText";
import { PropertyTypeSelector } from "@/features/LG/components/shared";

export const Home = () => {
  return (
    <VStack spacing={2} alignItems="stretch">
      <UserText>
        査定したい物件の種類を選択し、物件の情報を入力してください。
      </UserText>
      <PropertyTypeSelector />
    </VStack>
  );
};
